<template>
  <v-app>
    <!-- <IntroAnimation /> -->

    <div style="position: absolute; z-index: -1; width: 1px; height: 0px">
      <template v-for="(project, p) in proyectos">
        <div :key="p">
          <img
            :src="'https://www.chaptercms.actstudio.xyz' + project.cover.path"
            alt=""
          />
        </div>
      </template>

      <template v-for="(asset, at) in resource.content">
        <template v-for="(gallery, img) in asset.value.Gallery">
          <div :key="at + '-' + img">
            <img
              :src="'https://www.chaptercms.actstudio.xyz/' + gallery.path"
              alt=""
            />
          </div>
        </template>
      </template>
    </div>

    <transition name="fade-transition">
      <div class="loading-div" v-if="showLoading">
        <v-container fluid class="py-0">
          <v-row class="loading-div__row" align="center">
            <v-col
              cols="12"
              md="8"
              lg="7"
              offset-md="4"
              offset-lg="5"
              class="pa-0"
            >
              <v-progress-linear
                :value="charging"
                :height="loadingBarHeight"
                background-opacity="0"
                color="black"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </transition>

    <v-container fluid class="py-0">
      <!-- ***********************menú mobile*************************** -->
      <v-row
        class="justify-space-between menu-horizontal-mobile px-4 mb-4 mobile-menu-padding"
      >
        <v-col cols="auto" class="align-self-center">
          <div id="top" @mouseover="studioHide" @mouseleave="studioShow">
            <router-link to="/" class="color-black">
              <v-img
                src="@/assets/icons/chapterstudio-logo.svg"
                class="logo-chapter-new"
              ></v-img>

              <!-- <span class="title-app SctoGroteskAMedium logo">
                <span class="SctoGroteskAMedium position-relative"
                  >Chapter<span
                    v-if="!studio"
                    class="copy copy-desk SctoGroteskAMedium"
                    v-bind:class="{ 'move-left': studio == false }"
                    >&reg;</span
                  >
                </span>
                <span
                  v-bind:class="{ dissapear: studio == false }"
                  class="SctoGroteskAMedium"
                  >Studio</span
                >
                <span
                  v-if="studio"
                  class="copy copy-desk SctoGroteskAMedium"
                  v-bind:class="{ 'move-left': studio == false }"
                  >&reg;</span
                >
              </span> -->
            </router-link>
          </div>
        </v-col>
        <v-col cols="auto" class="align-self-center position-relative">
          <div
            @click="toggleMobile()"
            v-bind:class="{ mostrar: chapterCopy }"
            id="menu-bar"
          >
            <v-img
              src="@/assets/icons/flecha-menu.svg"
              width="100%"
              class="menu-arrow"
              v-bind:class="{ 'arrow-animation': chapterCopy }"
            ></v-img>
          </div>
        </v-col>
      </v-row>

      <section
        class="menu_mobile text-right"
        id="menu_mobile"
        v-bind:class="{ mostrar: chapterCopy }"
      >
        <div class="menu_mobile-div-container">
          <div class="position-menu-mobile line-height-5-mobile">
            <div
              id="about-contact"
              class="pb-2 mt-sm-5"
              v-bind:class="{
                'opacity-class': chapterCopy == false,
                animation: chapterCopy,
              }"
            >
              <ul class="px-0 not-list-style">
                <li>
                  <router-link to="/clients" class="title-app">{{
                    $t("btnClients")
                  }}</router-link>

                  <!-- mobile menu projects -->
                  <!-- <transition name="fade">
                    <div v-if="menuProjectsNew" class="d-flex mt-4" id="menu-expand-mobile">
                      <div>
                        <div v-for="(proyecto, ipc) in proyectos" :key="ipc">
                          <template v-if="ipc%3 == 0">
                            <span @mouseover="mouseIn(ipc)" @mouseout="mouseOut()">
                              <router-link
                                class="text-app-2 SctoGroteskAMedium ns"
                                :to="'/project/'+proyecto.url"
                              >{{ proyecto.name }}</router-link>
                            </span>
                          </template>
                        </div>
                      </div>

                      <div>
                        <div v-for="(proyecto, ipc2) in proyectos" :key="ipc2">
                          <template v-if="ipc2%3==1">
                            <span @mouseover="mouseIn(ipc2)" @mouseout="mouseOut()">
                              <router-link
                                class="text-app-2 SctoGroteskAMedium ns"
                                :to="'/project/'+proyecto.url"
                              >{{ proyecto.name }}</router-link>
                            </span>
                          </template>
                        </div>
                      </div>

                      <div>
                        <div v-for="(proyecto, ipc3) in proyectos" :key="ipc3">
                          <template v-if="ipc3%3==2">
                            <span @mouseover="mouseIn(ipc3)" @mouseout="mouseOut()">
                              <router-link
                                class="text-app-2 SctoGroteskAMedium ns"
                                :to="'/project/'+proyecto.url"
                              >{{ proyecto.name }}</router-link>
                            </span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </transition>-->
                  <!-- mobile menu projects -->
                </li>
                <li>
                  <router-link to="/contact">
                    <span class="title-app">{{ $t("btnContact") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/information" class="title-app">{{
                    $t("btnInformation")
                  }}</router-link>
                </li>
              </ul>
            </div>

            <!-- tablet vertical -->
            <template v-if="renderInfo">
              <div id="project-active" class="d-none d-sm-block">
                <div>
                  <v-row class="d-flex d-md-none">
                    <v-col cols="12" class="pb-0 pt-12">
                      <div>
                        <span class="d-block contact-left SctoGroteskAMedium"
                          >Contact</span
                        >
                      </div>
                      <div class="margin-custom-custom-55">
                        <a
                          :href="'tel:' + information.phone.phone_link"
                          class="color-black opacity-60"
                        >
                          <span
                            class="d-block contact-left SctoGroteskAMedium"
                            >{{ information.phone.phone_text }}</span
                          >
                        </a>
                      </div>
                      <div class="margin-custom-custom-55">
                        <a
                          :href="'mailto:' + information.email"
                          target="_blank"
                          class="color-black"
                        >
                          <span
                            class="d-block contact-left SctoGroteskAMedium"
                            >{{ information.email }}</span
                          >
                        </a>
                      </div>
                      <div class="margin-custom-custom-55">
                        <a
                          :href="information.address.address_link"
                          target="_blank"
                          class="color-black SctoGroteskAMedium opacity-60"
                        >
                          <span
                            class="d-block contact-left SctoGroteskAMedium opacity-60 words2"
                            >{{ information.address.address_text }}</span
                          >
                        </a>
                      </div>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <div class="networks-menu-mobile">
                        <a
                          :href="information.social_network_1"
                          class="color-black d-inline-block opacity-60"
                        >
                          <v-img
                            src="@/assets/icons/instagram.svg"
                            class="instagram-icon"
                          ></v-img>
                        </a>
                        <a
                          :href="information.social_network_2"
                          class="color-black d-inline-block opacity-60"
                        >
                          <v-img src="@/assets/icons/facebook.svg"></v-img>
                        </a>
                        <a
                          :href="information.social_network_3"
                          target="_blank"
                          class="color-black d-inline-block opacity-60"
                        >
                          <v-img src="@/assets/icons/behance.svg"></v-img>
                        </a>
                        <a
                          :href="information.social_network_4"
                          target="_blank"
                          class="color-black d-inline-block opacity-60"
                        >
                          <v-img src="@/assets/icons/spotify.svg"></v-img>
                        </a>
                      </div>
                      <div>
                        <span
                          class="contact-span d-block title-app SctoGroteskAMedium line-height-9255111"
                        >
                          Full portfolio / credentials package
                          <br />is available
                          <a
                            :href="'mailto:' + information.email"
                            target="_blank"
                            class="email-chapter"
                            >upon request</a
                          >
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </template>
            <!-- tablet vertical -->

            <!-- first menu -->
          </div>

          <!-- tablet vertical -->
          <div class="pl-4 margin-eng-esp d-none d-sm-block">
            <div class="position-relative">
              <span class="title-app position-relative">
                <span
                  class="cursor-pointer pr-6 lang-color"
                  v-bind:class="{ 'active-lang': lang == 'es' }"
                  @click="setLocale('es')"
                  >Spa</span
                >
                <span
                  class="cursor-pointer lang-color"
                  @click="setLocale('en')"
                  v-bind:class="{ 'active-lang': lang == 'en' }"
                  >Eng</span
                >
              </span>
            </div>
          </div>
          <!-- /tablet vertical -->

          <div
            class="date-and-terms-mobile"
            v-bind:class="{
              'opacity-class': chapterCopy == false,
              animation: chapterCopy,
            }"
          >
            <div>
              <div class="title-app">&copy;{{ date }}</div>
            </div>

            <!-- tablet vertical -->
            <div class="d-none d-sm-block">
              <div>
                <span class="small-text">
                  <router-link to="/terms" class="color-black">
                    <span class="opacity-60 cursor-pointer">{{
                      $t("btnTerms")
                    }}</span>
                  </router-link>
                  <span class="padding-x-terms">/</span>
                  <router-link to="/privacy" class="color-black">
                    <span class="opacity-60 cursor-pointer">{{
                      $t("btnPrivacyPolicy")
                    }}</span>
                  </router-link>
                </span>
              </div>
            </div>
            <!-- /tablet vertical -->

            <!-- mobile -->
            <div class="margin-eng-esp d-sm-none">
              <div class="position-relative">
                <span class="title-app position-relative">
                  <span
                    class="cursor-pointer pr-3 lang-color"
                    @click="setLocale('es')"
                    v-bind:class="{ 'active-lang': lang == 'es' }"
                    >Spa</span
                  >
                  <span
                    class="cursor-pointer lang-color"
                    v-bind:class="{ 'active-lang': lang == 'en' }"
                    @click="setLocale('en')"
                    >Eng</span
                  >
                </span>
              </div>
            </div>
            <!-- /mobile -->
          </div>
        </div>
      </section>
      <!-- ***********************menú mobile*************************** -->

      <!-- ***********************/menú mobile*************************** -->
      <v-row>
        <v-col
          cols="12"
          md="4"
          lg="5"
          class="padding-custom-logo col-without-scroll col-others-resolutions first-column"
          v-bind:class="{
            'scroll-y': openProjects2 == false,
            'scroll-y-section-0': menu == 0,
            'scroll-y-section-4': menu == 4,
          }"
        >
          <div
            id="top"
            @mouseover="studioHide"
            @mouseleave="studioShow"
            class="animation"
            style="animation-delay: 6s"
          >
            <router-link to="/" class="color-black">
              <template v-if="studio">
                <v-img
                  src="@/assets/icons/chapterstudio-logo.svg"
                  class="logo-chapter-new"
                ></v-img>
              </template>

              <template v-else-if="!studio">
                <v-img
                  src="@/assets/icons/chapter-logo.svg"
                  class="logo-chapter-new"
                ></v-img>
              </template>
              <!-- <span class="title-app SctoGroteskAMedium logo">
                <span class="SctoGroteskAMedium position-relative"
                  >Chapter<span
                    v-if="!studio"
                    class="copy copy-desk SctoGroteskAMedium"
                    v-bind:class="{ 'move-left': studio == false }"
                    >&reg;</span
                  >
                </span>
                <span
                  v-bind:class="{ dissapear: studio == false }"
                  class="SctoGroteskAMedium"
                  >Studio</span
                >
                <span
                  v-if="studio"
                  class="copy copy-desk SctoGroteskAMedium"
                  v-bind:class="{ 'move-left': studio == false }"
                  >&reg;</span
                >
              </span> -->
            </router-link>
          </div>
          <!-- texto por si acaso -->
          <!-- <div
            v-if="menu == 0"
            class="text-chapter-2 animation"
            style="animation-delay: 6s"
          >
            <span
              class="project-description-app rewrite-font d-block margin-bottom-in-text SctoGroteskAMedium"
              style="margin-top: 0px"
              >Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Recusandae consequuntur quasi
            </span>

            <span
              class="project-description-app rewrite-font d-block margin-bottom-in-text SctoGroteskAMedium"
              style="margin-top: 0px"
              >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi
              voluptate illum obcaecati eos quas quo explicabo pariatur
              molestias aperiam quae aliquam, soluta debitis. Nostrum placeat
              assumenda adipisci error similique voluptates.</span
            >

            <span
              class="project-description-app rewrite-font SctoGroteskAMedium"
              >Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Cupiditate, voluptates.</span
            >
          </div> -->
          <div
            v-show="menu == 3 || menu == 4 || menu == 5"
            class="padding-custom-app-project1"
          >
            <v-img
              @click="menuProjectsNewFunction()"
              src="@/assets/icons/flecha-menu.svg"
              class="menu-arrow-desk cursor-pointer"
              v-bind:class="{
                'arrow-animation-desk': menuProjectsNew,
                'arrow-back': menu == 4 || menu == 5,
              }"
            ></v-img>
          </div>

          <!-- ********new menu******** -->
          <transition name="fade">
            <div
              v-if="menuProjectsNew"
              class="d-flex line-height-menu-projects padding-custom-app-project2"
              id="menu-expand-projects"
            >
              <div>
                <div v-for="(proyecto, ipc) in proyectos" :key="ipc">
                  <template v-if="ipc % 2 == 0">
                    <span
                      @mouseover="mouseIn(ipc, proyecto._id)"
                      @mouseleave="mouseOut()"
                    >
                      <router-link
                        class="text-app-2 ns"
                        :class="proyecto._id"
                        :to="'/project/' + proyecto.url"
                        >{{ proyecto.name }}</router-link
                      >
                    </span>
                  </template>
                </div>
              </div>

              <div class="column-2-menu-projects">
                <div v-for="(proyecto, ipc2) in proyectos" :key="ipc2">
                  <template v-if="ipc2 % 2 == 1">
                    <span
                      @mouseover="mouseIn(ipc2, proyecto._id)"
                      @mouseout="mouseOut()"
                    >
                      <router-link
                        class="text-app-2 ns"
                        :to="'/project/' + proyecto.url"
                        :class="proyecto._id"
                        >{{ proyecto.name }}</router-link
                      >
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </transition>

          <div class="margin-custom-project-app wordbreak" v-if="menu == 4">
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <div>
                  <div
                    class="line-height-3 animation"
                    style="animation-delay: 1s"
                  >
                    <div style="line-height: 0.8">
                      <span
                        class="title-projects uppercase SctoGroteskAMedium"
                        >{{ project.name }}</span
                      >
                    </div>

                    <!-- <template v-if="project.subtitle != null">
                      <div class="margin-custom-app-project">
                        <span class="subtitle-app SctoGroteskAMedium">{{
                          project.subtitle
                        }}</span>
                      </div>
                    </template> -->
                  </div>

                  <div
                    class="max-width-app-project-texts animation line-height-4"
                    style="animation-delay: 1.4s"
                  >
                    <span class="words d-block project-description-app">{{
                      project.project_description
                    }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- btns terms / privacy-policy -->
          <transition name="fade">
            <div
              v-if="menu == 6"
              class="padding-custom-app-project2"
              id="btns-terms-privacy"
            >
              <ul class="not-list-style px-0">
                <li>
                  <router-link to="/terms" class="color-black">
                    <span class="title-app">{{ $t("btnTerms") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/privacy" class="color-black">
                    <span class="title-app">{{ $t("btnPrivacyPolicy") }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </transition>
          <!-- //btns terms / privacy-policy -->

          <!-- ********/new menu******** -->

          <div class="text-chapter">
            <transition name="text">
              <section
                class="transition-section"
                v-bind:class="{
                  menu_opciones:
                    menu == 0 ||
                    menu == 1 ||
                    menu == 3 ||
                    menu == 4 ||
                    menu == 5 ||
                    menu == 6,
                  'menu_opciones-section-0': menu == 0,
                  'menu_opciones-section-4': menu == 4,
                  prueba: menu != 0,
                }"
              >
                <div
                  v-bind:class="{
                    margin_top:
                      menu == 0 ||
                      menu == 1 ||
                      menu == 3 ||
                      menu == 4 ||
                      menu == 5 ||
                      menu == 6,
                    'margin_top-section-4': menu == 4,
                    'margin_top-section-0': menu == 0,
                    margin_leave: menu == 2 || menu == 3 || menu == 4,
                  }"
                >
                  <div>
                    <div
                      class="height-menu-opciones"
                      v-bind:class="{ remove: menu == 2, 'py-0': menu != 2 }"
                    >
                      <div
                        class="animation"
                        style="animation-delay: 1.6s"
                        v-if="showMenuServices"
                        id="menu-line"
                      >
                        <template
                          v-if="
                            singletonCategoria1.activo == true ||
                            singletonCategoria2.activo == true ||
                            singletonCategoria3.activo == true
                          "
                        >
                          <div>
                            <router-link
                              to="/clients"
                              class="padding-right-menu-services"
                            >
                              <span class="title-app">{{
                                $t("btnProjects")
                              }}</span>
                            </router-link>
                          </div>
                        </template>

                        <template v-if="singletonCategoria2.activo == true">
                          <div>
                            <router-link
                              to="/photography"
                              class="padding-right-menu-services"
                            >
                              <span class="title-app">{{
                                singletonCategoria2.title
                              }}</span>
                            </router-link>
                          </div>
                        </template>

                        <template v-if="singletonCategoria1.activo == true">
                          <div>
                            <router-link
                              to="/packaging"
                              class="padding-right-menu-services"
                            >
                              <span class="title-app">{{
                                singletonCategoria1.title
                              }}</span>
                            </router-link>
                          </div>
                        </template>

                        <template v-if="singletonCategoria3.activo == true">
                          <div>
                            <router-link to="/branding">
                              <span class="title-app">{{
                                singletonCategoria3.title
                              }}</span>
                            </router-link>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div
                      id="about-contact"
                      class="line-height-btns position-relative"
                      v-bind:class="{ 'padding-top-clients-app': menu == 2 }"
                    >
                      <ul
                        class="not-list-style px-0 animation"
                        style="animation-delay: 6s"
                      >
                        <li>
                          <router-link to="/clients">
                            <span class="title-app">{{
                              $t("btnClients")
                            }}</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/contact">
                            <span class="title-app">{{
                              $t("btnContact")
                            }}</span>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/information">
                            <span class="title-app">{{
                              $t("btnInformation")
                            }}</span>
                          </router-link>
                        </li>
                      </ul>

                      <v-img
                        src="@/assets/icons/flecha-new.svg"
                        class="arrow-flecha-big animation"
                        style="animation-delay: 6s"
                        contain
                        v-if="menu == 0 && $vuetify.breakpoint.mdAndUp"
                        v-bind:class="{ 'grow-arrow': !doAnimation }"
                      ></v-img>
                    </div>

                    <template v-if="renderInfo">
                      <transition name="contact-app-fade">
                        <div
                          class="margin-custom-3"
                          id="selected-work-btn"
                          v-show="openContactInformation && menu == 2"
                        >
                          <div class="app-contact">
                            <ul class="ul-contact">
                              <li>
                                <span
                                  class="d-block contact-left SctoGroteskAMedium"
                                  >Contact</span
                                >
                              </li>
                              <li>
                                <a
                                  :href="'tel:' + information.phone.phone_link"
                                  class="color-black"
                                >
                                  <span
                                    class="d-block contact-left opacity-60 SctoGroteskAMedium"
                                    >{{ information.phone.phone_text }}</span
                                  >
                                </a>
                              </li>
                              <li>
                                <a
                                  :href="'mailto:' + information.email"
                                  class="color-black"
                                >
                                  <span
                                    class="d-block contact-left hover-underline SctoGroteskAMedium"
                                    >{{ information.email }}</span
                                  >
                                </a>
                              </li>
                              <li class="line-height-1">
                                <a
                                  :href="information.address.address_link"
                                  target="_blank"
                                  class="color-black"
                                >
                                  <span
                                    class="words2 d-block contact-left opacity-60 SctoGroteskAMedium"
                                    >{{ information.address.address_text }}
                                  </span>
                                </a>
                              </li>
                              <li class="line-height-3">
                                <span
                                  class="contact-span d-block title-app SctoGroteskAMedium"
                                >
                                  Full portfolio / credentials package
                                  <br />
                                  is available
                                  <a
                                    :href="'mailto:' + information.email"
                                    target="_blank"
                                    class="email-chapter"
                                    >upon request.</a
                                  >
                                </span>
                              </li>
                              <li>
                                <!-- other list -->
                                <ul class="ul-social-media">
                                  <li>
                                    <a
                                      :href="information.social_network_1"
                                      class="color-black"
                                    >
                                      <v-img
                                        src="@/assets/icons/instagram.svg"
                                        class="instagram-icon opacity-60"
                                      ></v-img>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      :href="information.social_network_2"
                                      class="color-black"
                                    >
                                      <v-img
                                        src="@/assets/icons/facebook.svg"
                                        class="facebook-icon opacity-60"
                                      ></v-img>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      :href="information.social_network_3"
                                      target="_blank"
                                      class="color-black"
                                    >
                                      <v-img
                                        src="@/assets/icons/behance.svg"
                                        class="behance-icon opacity-60"
                                      ></v-img>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      :href="information.social_network_4"
                                      target="_blank"
                                      class="color-black"
                                    >
                                      <v-img
                                        src="@/assets/icons/spotify.svg"
                                        class="spotify-icon opacity-60"
                                      ></v-img>
                                    </a>
                                  </li>
                                </ul>
                                <!-- /other list -->
                              </li>
                            </ul>
                          </div>
                        </div>
                      </transition>
                    </template>

                    <v-fade-transition>
                      <div
                        class="menu_proyectos col-without-scroll"
                        id="project-active"
                        v-show="openProjects2"
                      >
                        <ul
                          style="padding-left: 40px"
                          class="not-list-style mb-8"
                        >
                          <li
                            v-for="(proyecto, i) in proyectos"
                            v-bind:key="i"
                            @mouseover="mouseIn(i)"
                            @mouseout="mouseOut"
                          >
                            <transition name="fade">
                              <router-link
                                class="ns"
                                :to="'/project/' + proyecto.url"
                                >{{ proyecto.name }}</router-link
                              >
                            </transition>
                          </li>
                        </ul>
                        <!-- first menu -->
                      </div>
                    </v-fade-transition>
                  </div>
                  <!--  -->
                  <div
                    class="title-app text-copy-chapter text-copy-chapter-position animation"
                    style="animation-delay: 6s"
                    v-bind:class="{
                      'text-copy-chapter-position-absolute': openProjects2,
                      'text-copy-chapter-position-section-0': menu == 0,
                      'text-copy-chapter-position-section-4': menu == 4,
                    }"
                    id="text-copy-chapter"
                  >
                    &copy;{{ date }}
                  </div>
                </div>
              </section>
            </transition>
          </div>
        </v-col>

        <v-col
          cols="12"
          md="8"
          lg="7"
          class="px-0 py-0"
          @mouseover="hideProjects()"
          @mouseout="showProjects()"
        >
          <div
            id="right-column"
            class="col-without-scroll col-two-scroll height-col-mobile"
            v-bind:class="{ 'height-col-mobile-home': menu == 0 }"
          >
            <div class="eng-esp-position">
              <span class="hidden-sm-and-down title-app position-relative">
                <span
                  class="cursor-pointer padding-custom-esp lang-color"
                  v-bind:class="{ 'active-lang': lang == 'es' }"
                  @click="setLocale('es')"
                  >Spa</span
                >
                <span
                  class="cursor-pointer lang-color"
                  v-bind:class="{ 'active-lang': lang == 'en' }"
                  @click="setLocale('en')"
                  >Eng</span
                >
              </span>
            </div>
            <transition name="fade">
              <router-view
                @update="actualizar"
                v-bind:showContent="showContent"
              />
            </transition>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import IntroAnimation from "@/components/IntroAnimation.vue";
import Vue from "vue";
import VueScrollTo from "vue-scrollto/vue-scrollto.js";

Vue.use(VueScrollTo, {
  el: "#right-column",
  container: "#right-column",
});

export default {
  name: "App",
  components: {
    IntroAnimation,
  },
  data: () => ({
    showContent: 0,

    //animation intro
    loadingBarHeight: "10px",
    showLoading: true,
    charging: 0,
    top: -9999,
    menu: 0,
    proyectos: [],
    menu_abierto: false,
    openContactInformation: false,
    doAnimation: true,
    // categories: [],
    openProjects2: false,
    singletonCategoria1: {},
    singletonCategoria2: {},
    singletonCategoria3: {},
    singletonCategoria4: {},
    singletonCategoria5: {},
    singletonCategoria6: {},
    information: {},
    renderInfo: false,

    //menú mobile
    menu_mobile: false,
    chapterCopy: false,

    //menú projects
    menuProjectsNew: false,

    //hide menu views
    menuViews: false,
    showMenuServices: false,
    project: {},

    studio: true,
    lang: "en",
    resource: {},
  }),
  computed: {
    date() {
      var dateToFormat = new Date();
      var year = dateToFormat.getFullYear();

      return year;
    },
  }, //end computed
  watch: {
    lang() {
      var aux = this;

      if (this.$i18n.locale == "en") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                url: this.$route.params.project,
              },
              sort: {
                _created: -1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.project = res.entries[0]));

        //obtener collections de todos los proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              sort: {
                _o: 1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));

        //****************************************obtener singleton categoria 1
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria1 = data));

        //****************************************obtener singleton categoria 2
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria2 = data));

        //****************************************obtener singleton categoria 3
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria3 = data));

        //****************************************obtener singleton categoria 4
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria4 = data));

        //****************************************obtener singleton categoria 5
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria5 = data));

        //****************************************obtener singleton categoria 6
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria6 = data));
      } //endif;
      else if (this.$i18n.locale == "es") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                url: this.$route.params.project,
              },
              lang: "es",
              sort: {
                _created: -1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.project = res.entries[0]));

        //obtener collections de todos los proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              sort: {
                _o: 1,
              },
              lang: "es",
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));

        //****************************************obtener singleton categoria 1
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria1 = data));

        //****************************************obtener singleton categoria 2
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria2 = data));

        //****************************************obtener singleton categoria 3
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria3 = data));

        //****************************************obtener singleton categoria 4
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria4 = data));

        //****************************************obtener singleton categoria 5
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria5 = data));

        //****************************************obtener singleton categoria 6
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria6 = data));
      }
    },
    $route(to, from) {
      var aux = this;

      setTimeout(() => {
        aux.doAnimation = true;
      }, 500);
      if (to.name == "home") {
        setTimeout(() => {
          aux.doAnimation = false;
        }, 8000);
        aux.charging = 0;
        this.loadingBarHeight = "10px";

        this.showLoading = true;

        //aparición de linea
        setTimeout(() => {
          aux.charging = 100;
          // aux.disolveLoading();
        }, 1000);

        //duración
        setTimeout(() => {
          // aux.charging = 100;
          aux.disolveLoading();
        }, 3000);
      }

      this.chapterCopy = false;
      if (this.$i18n.locale == "en") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                url: this.$route.params.project,
              },
              sort: {
                _created: -1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.project = res.entries[0]));

        //obtener collections de todos los proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              sort: {
                _o: 1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));

        //****************************************obtener singleton categoria 1
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria1 = data));

        //****************************************obtener singleton categoria 2
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria2 = data));

        //****************************************obtener singleton categoria 3
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria3 = data));

        //****************************************obtener singleton categoria 4
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria4 = data));

        //****************************************obtener singleton categoria 5
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria5 = data));

        //****************************************obtener singleton categoria 6
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3"
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria6 = data));
      } //endif;
      else if (this.$i18n.locale == "es") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                url: this.$route.params.project,
              },
              lang: "es",
              sort: {
                _created: -1,
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.project = res.entries[0]));

        //obtener collections de todos los proyectos
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                published: true,
              },
              sort: {
                _o: 1,
              },
              lang: "es",
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.proyectos = res.entries));

        //****************************************obtener singleton categoria 1
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria1 = data));

        //****************************************obtener singleton categoria 2
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria2 = data));

        //****************************************obtener singleton categoria 3
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria3 = data));

        //****************************************obtener singleton categoria 4
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria4 = data));

        //****************************************obtener singleton categoria 5
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria5 = data));

        //****************************************obtener singleton categoria 6
        fetch(
          "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "es",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (aux.singletonCategoria6 = data));
      } //endelseif;
    },
    menu: function (val) {
      if (this.menu == 4 || this.menu == 5 || this.menu == 6) {
        this.menuProjectsNew = false;
      }
    },
  }, //endWatch;
  beforeCreate() {
    fetch(
      "https://www.chaptercms.actstudio.xyz/api/singletons/get/assetPrincipal?token=6f2367a659983f01bf66f378fcfcd3"
    )
      .then((data) => data.json())
      .then((data) => (this.resource = data));
  },
  created: function () {
    var aux = this;

    try {
      //fetch to get thw information
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/information?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.information = data))
        .then((data) => (this.renderInfo = true))
        .catch((error) => console.log(error.message));
    } catch (err) {
      console.log(err.message);
    }

    if (this.$i18n.locale == "en") {
      //obtener un proyecto del parametro de projecto
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              url: this.$route.params.project,
            },
            sort: {
              _created: -1,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.project = res.entries[0]));

      //obtener collections de todos los proyectos
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              published: true,
            },
            sort: {
              _o: 1,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.proyectos = res.entries));

      //****************************************obtener singleton categoria 1
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria1 = data));

      //****************************************obtener singleton categoria 2
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria2 = data));

      //****************************************obtener singleton categoria 3
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria3 = data));

      //****************************************obtener singleton categoria 4
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria4 = data));

      //****************************************obtener singleton categoria 5
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria5 = data));

      //****************************************obtener singleton categoria 6
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3"
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria6 = data));
    } //end if;
    else if (this.$i18n.locale == "es") {
      //obtener un proyecto del parametro de projecto
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              url: this.$route.params.project,
            },
            lang: "es",
            sort: {
              _created: -1,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.project = res.entries[0]));

      //obtener collections de todos los proyectos
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/collections/get/Projects?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              published: true,
            },
            sort: {
              _o: 1,
            },
            lang: "es",
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.proyectos = res.entries));

      //****************************************obtener singleton categoria 1
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria1?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria1 = data));

      //****************************************obtener singleton categoria 2
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria2?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria2 = data));

      //****************************************obtener singleton categoria 3
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria3?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria3 = data));

      //****************************************obtener singleton categoria 4
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria4?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria4 = data));

      //****************************************obtener singleton categoria 5
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria5?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria5 = data));

      //****************************************obtener singleton categoria 6
      fetch(
        "https://www.chaptercms.actstudio.xyz/api/singletons/get/categoria6?token=6f2367a659983f01bf66f378fcfcd3",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "es",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (aux.singletonCategoria6 = data));
    } //end elseif;
  }, //end beforeCreate
  mounted: function () {
    var aux = this;

    // animación de la flecha
    setTimeout(() => {
      this.doAnimation = false;
    }, 8000);

    //aparición de linea
    setTimeout(() => {
      aux.charging = 100;
      // aux.disolveLoading();
    }, 1000);

    aux.charging = 0;

    //duración
    setTimeout(() => {
      // aux.charging = 100;
      aux.disolveLoading();
    }, 3000);
  }, //end mounted
  methods: {
    disolveLoading: function () {
      var aux = this;

      this.loadingBarHeight = "100vh";
      setTimeout(() => {
        aux.showLoading = false;
        aux.showContent = 1500;
      }, 4000);
    },
    menuProjectsNewFunction: function () {
      if (this.menu != 4 && this.menu != 5) {
        this.menuProjectsNew = !this.menuProjectsNew;
      } else if (this.menu == 4 || this.menu == 5) {
        this.$router.push("/clients");
      }
    },
    hideProjects: function () {
      if (this.menu == 3) {
        this.showMenuServices = false;
      }
    },
    showProjects: function () {
      if (this.menu == 3 || this.menu == 5) {
        this.showMenuServices = true;
      }
    },
    mouseIn: function (i, id) {
      /*método cuando haces hover en proyecto
      selecciona el proyecto en el menú de projects
    */
      var workProject = document.querySelectorAll(".work-project"); //selecciona la clase de los proyectos

      for (var x = 0; x < workProject.length; x++) {
        //recorre cada proyecto del feed de proyectos
        if (i == x) {
          // alert(id);
          //valida si el parámetro enviado del proyecto(índice) de cada proyecto en el que se hace hover es igual a cada elemento del menú de proyects y le agrega una clase a cada elemento para saber el proyecto en el que se hizo project
          workProject[x].classList.add("overlay2");

          workProject[x].setAttribute("id", "project-scroll");

          var rightColumn = document.getElementById("right-column");

          var projectScroll = document.getElementById("project-scroll")
            .offsetTop;
          var selector = document.getElementById("project-" + id);

          console.log($("#right-column").scrollTop());
          var body = $("#right-column ");
          body.animate(
            {
              scrollTop:
                $("#right-column").scrollTop() +
                $(".project-" + id).position().top,
            },
            {
              duration: 1000,
              queue: false,
            }
          );
          // body.stop().animate({ scrollTop: $('#right-column').scrollTop() + $('.project-'+id).position().top }, 1000, "swing", function () {
          //   // alert("Finished animating");
          // }, 5000);
        }
      }
    },
    mouseOut: function () {
      /*método cuando dejas de hacer hover en los proyectos
       */
      var workProject = document.querySelectorAll(".work-project"); //selecciona la clase de los proyectos
      for (var x = 0; x < workProject.length; x++) {
        //recorre cada proyecto del menú de projects
        workProject[x].classList.remove("overlay2"); //le remueve la clase que se le pone en el método mouseIn

        workProject[x].removeAttribute("id", "project-scroll");
      }
    },
    studioShow: function () {
      this.studio = true;
    },
    studioHide: function () {
      this.studio = false;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.lang = locale;
      // console.log(this.lang);
    },
    actualizar(x) {
      this.menu = x;

      if (this.menu == 0 || this.menu == 1 || this.menu == 2) {
        //hide the menu of the services
        this.showMenuServices = false;

        //hide the menu with the projects
        this.menuProjectsNew = false;
      }

      // if (this.menu == 0) {
      //   this.openProjects2 = false;
      // }

      if (this.menu == 2) {
        this.openProjects2 = false;
        this.openContactInformation = true;
      }

      if (this.menu == 3) {
        //hide the menu of the services
        this.showMenuServices = true;

        //show the menu with the projects
        this.menuProjectsNew = true;
      }

      if (this.menu == 4 || this.menu == 5) {
        //show the menu of the services
        this.showMenuServices = false;
      }

      if (this.menu == 5) {
        //hide the menu of the services
        this.showMenuServices = true;
      }

      if (this.menu == 6) {
        //hide the menu of the services
        this.showMenuServices = false;
      }
    },
    //responsive
    openProjectsMobile: function () {
      this.openProjects2 = !this.openProjects2;
    },
    toggleMobile: function () {
      this.chapterCopy = !this.chapterCopy;
      window.scrollTo(0, 1);
    },
  }, //end methods
};
</script>